import 'babel-polyfill';
import React from 'react';
import {render} from 'react-dom';
import Routes from './routes';
import './styles/styles.css';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import {Provider} from 'mobx-react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import injectTapEventPlugin from 'react-tap-event-plugin';
import * as api from './libs/api';
import MarkerStore from './store/MarkerStore';
import ContentStore from './store/ContentStore';

const markerStore = new MarkerStore();
const contentStore = new ContentStore(api.content);

// console.log(markerStore)

injectTapEventPlugin();

const muiTheme = getMuiTheme({
  palette: {
    primary1Color: '#0f72a9'
  },
  tableRow: {
    height: 30,
  }
});

const App = () => (
  <Provider
    markerStore={markerStore}
    contentStore={contentStore}
  >
    <MuiThemeProvider muiTheme={muiTheme}>
      <Routes/>
    </MuiThemeProvider>
  </Provider>
);

render(
  <App/>,
  document.getElementById('app')
);



// WEBPACK FOOTER //
// ./src/index.js